/* Layout of Viewer on 'Per Document Basis */

require('./layout.less');

var fvChannel = require('glRadio').channel('FV'),
    Marionette = require('marionette'),
    BabySitterView = require('../common/BabySitterView'),
    $ = require('jquery'),

    HeaderCenter = require('./header/headerCenter/headerCenter'),
    HeaderLeft = require('./header/headerLeft/headerLeft'),
    HeaderRight = require('./header/headerRight/headerRight'),

    PanelCenterView = require('./panelCenter/panelCenterView'),
    PanelLeftView = require('./panelLeft/leftPanelView'),
    PanelRightView = require('./panelRight/rightPanelView'),

    /* TODO -- move to viewer 'view', with  */
    LoadingModal = require('../common/modalLoading/modalLoading'),
    Modal = require('../common/modal/modal');


require('jqIframeShim');


module.exports = Marionette.LayoutView.extend({

	template: require('./layout.hbs'),

    initialize: function() {
        BabySitterView.prototype.createChildren.call(this); /* (this.children) views not from regions */
    },

    onRender:  Backbone.View.prototype.unwrap,  //if get rid of unwrap, rid the leaks

    regions: {
        leftHeader:     '.FV-header-left',
        rightHeader:    '.FV-header-right',
        centerHeader:   '.FV-header-center',

        centerContent:  '.FV-center-content', /*('viewModes view rendered in this region */

        leftContent:    '.FV-side-left',
		rightContent:   '.FV-side-right',

        modal:          '.FV-modal-region'
	},

	ui: { /* Note: UI and Events Used in Layout but necessary in this view */
        header:         '.FV-header',
        panelCenter:    '.FV-center-wr'
    },

    onBeforeShow: function(view, region, options) {

        var vCh = options.lChannel.request('vChannel');

        this.centerHeader.show( new HeaderCenter({ vChannel: vCh }) );

        this.leftContent.show( new PanelLeftView() );
        this.rightContent.show( new PanelRightView() );

        this.leftHeader.show( new HeaderLeft({
            model: options.leftModel,
            vChannel: vCh,
            lChannel: options.lChannel
         }) );


        this.rightHeader.show( new HeaderRight( _.extend({
                model: options.rightModel,
                collection: options.notes,
                vChannel: vCh
            },
            _.pick(options, 'fullTextQuery', 'numberFTHits', 'lChannel') 
        )));


        // TODO: out of child?
        this.children
            .add( new PanelCenterView( _.extend(options, {
                el: this.ui.panelCenter,
                $rightPanel: this.rightContent.$el,
                $leftPanel: this.leftContent.$el,
                $layoutViewEl: view.$el
            })), 'panelCenter');

    },

    keyboardEvents: {

        '[': function() {
            this.options.lChannel.trigger('layout:toggleSidePanel', 'left');
        },

        ']': function() {
            this.options.lChannel.trigger('layout:toggleSidePanel', 'right');
        }

    },

    // TODO: currently not implemented
     _setMinWidth: function() {
         this.originalMinWidth = this.$el.getInlineStyle('min-width'); //store if exists before replacing in order to put it back
         this.$el.css('min-width', this.options.lChannel.request('vChannel').request('minimumWidth'));
    },
    onShowModal: function(options, isLoading) {

        /* the first shows if the view is already made; the latter expects content */

        if ( options && options.modalView && options.modalView instanceof Modal ) {
            options.modalView.settings.$container = this.$el; //TODO: setter fn
            this.modal.show( options.modalView );
            return options;
        }

        var opts = _.extend( options, {
                $container: this.$el
            }),
            ModalType = !isLoading ? Modal : LoadingModal,
            view = this.modal.show( new ModalType(opts) );

        return view; //todo: what reliant on return

    },
    onCloseModal: function() {
        this.modal.empty();
    },
    onToggleFullScreen: function(isFullScreen) {
        this.centerHeader.currentView.triggerMethod('toggleFullScreen', isFullScreen);
        this.rightHeader.currentView.command('toggleFullScreen', isFullScreen);
    },
    /*
     * paneToggledOpen, windowResize
     * TODO: if made smaller on initial the was before and resize -- set size back ... minor -- could keep %'s on a model
     * whole system would be much better IF model driven
     */
    onResizeSidesIfOverlap: function(left, right) {

        var lIsOpen = left.isOpen(),
            rIsOpen = right.isOpen(),
            paneIsCovering = left.isCovering() || right.isCovering(),
            DIST_BUF = 100,//includes draggers (~4px each) //todo: store on center -- minWidth of that panel(?)
            $l =  this.leftContent.$el,
            $r =  this.rightContent.$el;

        /* Panel Covering */
        if (paneIsCovering) { //this applies to entering, now what size if open another
            var nw = this.options.lChannel.request('layoutWidth', true),
                paneCovering = lIsOpen ? left : right;
            paneCovering.updateWidth(nw, {fromResize: true});
            return; //exit
        }

        /* No Panel Covering */
        if (lIsOpen && rIsOpen) {

            /* BOTH OPEN If Both Panels Open, Change Width So they Don't Overlap */

            //i think c with is 0 when l and r width are the same ... (l.width and r.width are the same ... so diff btn is 0)
            // DVBC-984 --> NOW NOT USING CENTER WIDTH IN CALC, WHICH COULD BE ZERO (I THINK OCCURS WHEN R WIDTH AND L WIDTH ARE THE SAME)

            var lWidth = $l.width();
            var distBetweenPanelsLessBuffer = ( $r.offset().left - ($l.offset().left + $l.width()) ) - DIST_BUF;

            // No-resize necessary if already wide enough
            if (distBetweenPanelsLessBuffer >= 0)
                return;

            var distToMoveEachPanel = Math.abs(distBetweenPanelsLessBuffer) / 2;
            //assuming equal, could do ratio based off prior ...
            // todo: should do this ... eg if they were overlapping will be set to same size, really want set to size closest to the actual without overlapping

            //set the width to the current size of the width less the distance to move it,
            updatePanelWidths( Math.max( lWidth - distToMoveEachPanel, left.minWidth ), Math.max( $r.width() - distToMoveEachPanel, right.minWidth ) );

        } else {
            /* one side open */
            var nw = this.$el.width() - DIST_BUF,
                leftOpen = lIsOpen && !rIsOpen,
                rightOpen = !lIsOpen && rIsOpen;
            if (leftOpen && $l.width() > nw || rightOpen && $r.width() > nw ) updatePanelWidths(nw, nw);
        }


        function updatePanelWidths(leftW, rightW) {
            left.updateWidth(leftW, {fromResize: true}); /* flag WILL also update the center panel in model's update cb IN addition to the panel itself!!! - make clearer */
            right.updateWidth(rightW, {fromResize: true});
        }

    },
    destroy: function() {

        BabySitterView.prototype.onBeforeDestroy.call(this);
        Marionette.LayoutView.prototype.destroy.apply(this, arguments);

        /* Remove jq cache refs */
        this.$('*').remove();
        this.$el = null;
        this.el = null;
    }
});



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/layout/layoutView.js
 ** module id = 711
 ** module chunks = 0
 **/